// extracted by mini-css-extract-plugin
export default {"main":"_940abdb764 _34d69fcdce","xmark":"b016a4ea1a","fl_img":"b9283cdd64 _1c58c15137"};